/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import React from 'react';
import useDrag from '../hooks/useDrag.js';
import parseTNode from '../../_util/parseTNode.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_chunks/dep-2acfafca.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CustomFile = function CustomFile(props) {
  var classPrefix = props.classPrefix,
    displayFiles = props.displayFiles;
  var drag = useDrag(props.dragEvents);
  var dragActive = drag.dragActive;
  var dragEvents = props.draggable ? {
    onDrop: drag.handleDrop,
    onDragEnter: drag.handleDragenter,
    onDragOver: drag.handleDragover,
    onDragLeave: drag.handleDragleave
  } : {};
  var renderDragContent = function renderDragContent() {
    var childrenContent = parseTNode(props.childrenNode, {
      dragActive: dragActive,
      files: displayFiles
    });
    var triggerContent = parseTNode(props.trigger, {
      dragActive: dragActive,
      files: displayFiles
    });
    return /* @__PURE__ */React.createElement("div", _objectSpread(_objectSpread({
      className: "".concat(classPrefix, "-upload__dragger ").concat(classPrefix, "-upload__dragger-center")
    }, dragEvents), {}, {
      onClick: props.triggerUpload
    }), /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-upload__trigger")
    }, parseTNode(props.dragContent, {
      dragActive: dragActive,
      files: displayFiles
    }) || triggerContent || childrenContent));
  };
  return /* @__PURE__ */React.createElement(React.Fragment, null, props.draggable ? renderDragContent() : /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-upload__trigger"),
    onClick: props.triggerUpload
  }, props.childrenNode || props.children));
};
CustomFile.displayName = "CustomFile";

export { CustomFile as default };
//# sourceMappingURL=CustomFile.js.map
